import { useRuntimeSetting } from './useRuntimeSetting';

// @todo сделаем на нормальных данных, когда будет готов бэк, прогресс тут https://jira.cian.tech/browse/SUT-289
export const useIsDailyrentOnlineBooking = () => {
  return useRuntimeSetting<boolean>('Dailyrent.FakeDailyrentOnlineBooking.Enabled', false);
};
